import React from "react";
import TermsAndConditionsComp from "../../components/terms-and-conditions";

const TermsAndConditons = () => {
  return (
    <div>
      <TermsAndConditionsComp />
    </div>
  );
};

export default TermsAndConditons;
